<template>
  <div class="browser ">
    <div class="tree-close">
      <!-- <span class="pro-title"><i class="fa fa-align-left pro-title-icon"></i>树形查看</span> -->
      <span class="pro-title"><i class="icon iconfont icon-tree_line pro-title-icon"></i>树形查看</span>
      <i class="el-icon-error close-icon" @click="closeData"></i>
    </div>
    <el-tree class="browser-tree browser-scrollbar" :data="listData" :props="defaultProps"
      :expand-on-click-node='nodeExpand' highlight-current node-key="id" default-expand-all
      @node-click="handleNodeClick">
      <span slot-scope="{ node, data }">
        <span>
          <span v-if="data.classId == 30101 || data.classId == 30102" class="fa fa-stop"
            :style="{ color: statusColor[data.color].color }"></span>
          <span v-else style="margin-left:18px"></span>
        </span>
        <span class="node-type" :class="data.icon"> </span>
        <span class="label">
          <span v-if="data.classId == 30101 || data.classId == 30102">{{ data.seq }}</span> {{ node.label }}
        </span>
      </span>
    </el-tree>
  </div>
</template>

<script>
import axios from 'axios'
import '@/assets/css/icon-swift.css'
import 'font-awesome/css/font-awesome.min.css'
// import { log } from 'console';
export default {
  data() {
    return {
      defaultProps: {},
      nodeExpand: false,
      listData: [],
      typeList: [],
      statusColor: [
        { id: 1, color: '#13ce66', name: '正常阶段' },
        { id: 2, color: '#fcad2c', name: '需要注意' },
        { id: 3, color: '#F56C6C', name: '延迟阶段' },
        { id: 4, color: '#38a8f6', name: '暂停任务' },
        { id: 5, color: '#999', name: '关闭任务' }
      ]
    }
  },
  props: ['rootId',],
  methods: {
    handleNodeClick(data) {
      // console.log(data,this.$store.state.activedTabInHome);
      let name = data.label + data.id + data.classId + data.subclassId;
      if (name == this.$store.state.activedTabInHome) {
        return
      }
      let n = parseInt(data.classId.toString().substr(0, 3));
      let obj = {
        name: name,
        title: data.label,
        objClass: data.classId,
        objSubClass: data.subclassId,
        objId: data.id,
        rootId: this.listData[0].id,
        path: this.getPageUrl(n)
      }
      this.$emit('nodeClick', obj)
    },

    renderContent(h, { node, data, store }) {
      return (<span class={!data.children ? 'leafNode' : 'sNode'} style="cursor:pointer">{node.label}</span>)
    },
    closeData() {
      // this.listData = [];
      this.$emit('nodeClick',)
    },
    getData(e) {

      const n = this.$store.state.projectRootId;

      // console.log('sdfasdfasdfasdfad', e);
      // const n = e || this.rootId
      if (!n) {
        return
      }
      axios
        .get('/ppm/project/getProjectBrowserInfo?rootId=' + n)
        .then((res) => {
          this.transData([res.data.object.Info])
        })
    },

    getColor(a, b) {
      let n = !a ?
        (b < 4 ?
          0 :
          (b == 6 ?
            1 :
            (b == 4 ?
              4 :
              2))) :
        a == 1 ? 3 : 4;


      return n
    },
    transData(e) {

      const subList = [
        {
          id: '3010101',
          icon: 'el-icon-document-copy'
        },
        {
          id: '3010104',
          icon: 'el-icon-news'
        },
        {
          id: '3010201',
          icon: 'el-icon-collection-tag'
        },
        {
          id: '3010202',
          icon: 'el-icon-trophy'
        },
      ];
      let getListName = (arr, l, pLevel) => {
        let newArr = [];
        let level = l || 1;
        let parentLevel = pLevel || 0;
        let m = 1;

        arr.map(i => {
          let n = {
            label: i.name,
            id: i.classId ? i.id : i.shipObjId,
            classId: i.classId || i.clsId,
            subclassId: i.subclassId || i.subClsId,
            icon: subList.find(j => j.id == i.subclassId)?.icon || 'el-icon-connection',
            color: this.getColor(i.specialState, i.statusType),
            children: i.childProject,
            seq: ''
          };
          if (n.classId == 30101 || n.classId == 30102) {
            n.seq = level == 1 ? '' : !parentLevel ? m : parentLevel + '.' + m,
              m++
          }
          n.children = i.childProject || i.relationshipList ? [...i.relationshipList, ...i.childProject] : [];
          newArr.push(n);
          if (n.children?.length) {
            n.children = getListName(n.children, level + 1, n.seq);
          }

        });
        return newArr;
      };
      this.listData = getListName(e);
    }
  },
  created() {
    this.getData(this.rootId)
  }
};
</script>

<style>
.node-type {
  margin-left: 5px;
  font-weight: 900;
}

.label {
  cursor: pointer;
}

.browser {
  /* background: rgb(255, 255, 255,0.4); */
  background: #fff;
  /* border: 1px solid #fff; */
  border-radius: 6px;
  /* padding: 25px; */
  padding: 10px 0px;
  padding-bottom: 36px;
  max-height: 800px;
  overflow: auto;

}

.browser .el-tree {
  /* margin-left: 15px; */
  color: #303133;
  background: none;
}

.browser .el-tree__empty-block {
  display: none;
}

.browser .el-tree-node__content {
  height: 34px;
  line-height: 34px;
}

.browser .el-tree-node__content:hover {
  background: #5cb0f8;
  color: #fff;
}

.el-tree-node__expand-icon {
  color: #303133;
  /* font-size: 18px; */
}

.browser .el-tree-node:focus>.el-tree-node__content {
  background-color: #409EFF;
  /* color: #fff; */
}

.browser .el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content {
  background-color: #409EFF;
}


/* .browser .el-tree-node>.el-tree-node__label{
  font-size: 18px;
} */
.browser .el-tree-node .is-expanded .is-current .is-focusable {
  background: none;
}

.browser .el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content {
  /* background: #4588f9; */
  background: transparent;
  font-weight: 600;
  color: #5cb0f8;
}

.leafNode {
  font-size: 14px;
}

.sNode {
  font-size: 16px;
}
</style>

<style scoped>
.pro-title {
  width: 160px;
  overflow: hidden;
  float: left;
  font-size: 18px;
  height: 52px;
  line-height: 52px;
}

.pro-title-icon {
  margin-right: 6px;
  font-weight: 600;
  /* transform: rotate(90deg) rotateY(180deg); */
}

.tree-close {
  height: 48px;
  line-height: 48px;
  margin-bottom: 12px;
  padding-left: 15px;
  /* color: #409EFF; */
  /* border-bottom: 1px solid #DCDFE6; */
}

.close-icon {
  /* width: 18px;
  height: 18px;
  line-height: 18px; */
  font-size: 18px;
  float: right;
  margin-right: 25px;
  line-height: 48px;
  cursor: pointer;
  color: #ebeef5;
  transition: -webkit-transform .3s;
  -webkit-transition: -webkit-transform .3s;
  transition: transform .3s;
  transition: transform .3s, -webkit-transform .3s;
  transition: transform .3s, -webkit-transform .3s;
}

.close-icon:hover {
  color: #5cb0f8;
  -webkit-transform: rotate(90deg);
  transform: rotate(90deg);
}

/*滚动条的宽度*/
::-webkit-scrollbar {
  width: 8px;
  height: 9px;
}

/*外层轨道。可以用display:none让其不显示，也可以添加背景图片，颜色改变显示效果*/
::-webkit-scrollbar-track {
  width: 6px;
  background-color: #fff;
  -webkit-border-radius: 2em;
  -moz-border-radius: 2em;
  border-radius: 2em;
}

/*滚动条的设置*/
::-webkit-scrollbar-thumb {
  background-clip: padding-box;
  background-color: #cecece;
  min-height: 28px;
  -webkit-border-radius: 2em;
  -moz-border-radius: 2em;
  border-radius: 2em;
}

/*滚动条移上去的背景*/
/* ::-webkit-scrollbar-thumb:hover {
    background-color:#fff;
  } */
</style>